import { FC, useEffect, useState } from 'react';

interface IRandomTargetingIndicatorProps {
  randomizedTargetingKey: string | null;
}

const RandomTargetingIndicator: FC<IRandomTargetingIndicatorProps> = ({
  randomizedTargetingKey,
}) => {
  // Only render on client side
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!randomizedTargetingKey || !isClient) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '5px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(255, 213, 79, 0.9)',
        color: '#333',
        padding: '5px 10px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 'bold',
        zIndex: 9999,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      }}
    >
      <span role="img" aria-label="random" style={{ fontSize: '14px' }}>
        🎲
      </span>
      <div>
        <div>Using Random Subject ID</div>
        <div style={{ fontSize: '14px', opacity: 0.8 }}>{randomizedTargetingKey}</div>
      </div>
    </div>
  );
};

export default RandomTargetingIndicator;
